<template>
  <gg-modal :is-active="opened" @close="close">
    <template v-slot:toolbar>Delete Remote Host</template>
    <template v-slot:body>
      <p>Are you sure you wish to <strong>permanently</strong> remove “{{ host }}” as an access host?</p>
    </template>
    <template v-slot:actions class="justify-content-end">
      <gg-btn secondary @click="close" text color="green">Cancel</gg-btn>
      <gg-btn primary :loading="loading" @click="deleteHost">Delete</gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'DeleteHostModal',
  props: {
    host: {
      type: String,
      required: true,
    },
    opened: {
      type: Boolean,
      required: true,
    },
  },
  data () {
    return {
      loading: false,
    }
  },
  methods: {
    ...mapActions({
      deleteMysqlRemoteHost: 'mysql/deleteMysqlRemoteHost',
      reportSuccess: 'reportSuccess',
      reportError: 'reportError'
    }),
    async deleteHost () {
      try {
        this.loading = true

        await this.deleteMysqlRemoteHost({ host: this.host, _username: this.$route.query.user })

        this.reportSuccess(`Host “${this.host}” deleted.`)
        this.$emit('host-deleted')
        this.close()
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    },
    close () {
      this.$emit('close')
    }
  },
}
</script>
